<template>
  <div>
    <div class="left_list">
      <div class="left_list_title left_list_title2">
        <span>商务配套设施</span>
      </div>
      <div class="list_main_wrapper" style="margin-top: 60px">
        <div class="supply" v-for="(item,index) in dataList" :key="index">
          <div class="supply_txt">{{item.label}}</div>
          <div class="supply_process_wrapper">
            <div  :class="index==0?'supply_process supply_process_most':'supply_process'"></div>
          </div>
          <div class="supply_number">{{item.value}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "@/assets/js/swiper.min.js";
import * as echarts from "echarts";

export default {
  data() {
    return {
      dataList: [
        { label: "星级酒店", value: 4 },
        { label: "快捷连锁酒店", value: 4 },
        { label: "特色民宿", value: 4 },
        { label: "小型旅馆", value: 4 },
      ],
    };
  },
  props: {
    business_facilities: {
      typeof: Array,
      default: () => [],
    },
  },
  watch: {
    business_facilities: {
      deep: true,
      handler: function (newV, oldV) {
        this.getData();
      },
    },
  },
  components: {},
  mounted() {},

  created() {},
  methods: {
    getData() {
      console.log();
      for (let index = 0; index < 4; index++) {
        const e = this.business_facilities[index];
        this.dataList[index].label = e.label;
        this.dataList[index].value = e.value;
      }
    },
  },
};
</script>
<style scoped src="@/assets/css/index3.css">
</style>